import type { ReactNode } from 'react';

export const symbol_assignment_ind: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h207q-2-37 26-66.5t67-29.5q39 0 67 29.5t26 66.5h207q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm321.5-710.5Q510-839 510-852t-8.5-21.5Q493-882 480-882t-21.5 8.5Q450-865 450-852t8.5 21.5Q467-822 480-822t21.5-8.5ZM180-217q60-56 136-90.5T480-342q88 0 164 34.5T780-217v-563H180v563Zm400-244q40-40 40-98t-40-98q-40-40-98-40t-98 40q-40 40-40 98t40 98q40 40 98 40t98-40ZM235-180h490v-9q-54-46-116-69.5T480-282q-67 0-129 23.5T235-189v9Zm192-324q-23-23-23-55t23-55q23-23 55-23t55 23q23 23 23 55t-23 55q-23 23-55 23t-55-23Zm53 5Z"
		/>
	</svg>
);
